/**
 * Fade-Bottom / Blue-Red-Orange.
 */ var BlueRedOrange = [
    /**
     * Violet Props.
     */ {
        variant: 'violet',
        size: '971',
        rotate: 120,
        blur: 19.3,
        x: '309',
        y: '-779'
    },
    /**
     * Blue Props.
     */ {
        variant: 'blue',
        size: '911',
        rotate: 50,
        blur: 21.3,
        x: '-456',
        y: '-398'
    },
    /**
     * Red Props.
     */ {
        variant: 'red',
        size: '911',
        rotate: 30,
        blur: 21.3,
        x: '108',
        y: '-666'
    },
    /**
     * Orange Props.
     */ {
        variant: 'orange',
        size: '967',
        rotate: 130,
        blur: 21.3,
        x: '956',
        y: '-583'
    }
];

export { BlueRedOrange as default };
//# sourceMappingURL=blue-red-orange.es.js.map
